import React, { useState } from "react";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import SEO from "../components/seo";
import axios from "axios";
import { isEmpty, random } from "lodash";
import Layout from "../components/layout";
import { colors, Button, Input, GreenLink, Creatorlink } from "../style/theme";
import { mq } from "../utils/helper";
import { API_URL } from "../../env";

const isValidUrl = (url) =>
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
    url
  );

const isOnlyNumber = (str) => /^\d+$/.test(str);

const firstNum = random(0, 99);
const secondNum = random(0, 99);
const answer = firstNum + secondNum;

const Option = styled.div({
  width: "60%",
  display: "flex",
  marginTop: "1rem",
  justifyContent: "space-between",
  alignItems: "center",
  [mq[1]]: {
    display: "block",
    width: "100%",
  },
});

const Label = styled.label({
  marginBottom: "0.5rem",
  display: "inline-block",
});

function CheckifExist() {
  const [url, setUrl] = useState("");
  const [result, setResult] = useState("");
  const [color, setColor] = useState(colors.dark);
  return (
    <>
      <h4>في البداية تحقّق من وجود المدوّنة</h4>
      <p>
        قد تكون المدوّنة التي ترغب بإضافتها موجودةً بالفعل في قاعدة بياناتنا.
        لطفًا ضع رابطها في المربع أدناه واضغط على زر التحقّق.
      </p>
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          const res = await axios({
            method: "get",
            url: `${API_URL}/isexist/?url=${url}`,
            headers: {
              Authorization: "Basic ZWxmZWhyZXN0Ok5qNG1NSlEwd0Z6MUJTakR6THQz",
            },
          });
          if (res.data.status == 404) {
            setResult("عظيم! لقد وجدت مدونة جديدة");
            setColor(colors.green);
          } else if (res.data.status == 200) {
            setResult("المدونة موجودة بالفعل في قاعدة بياناتنا");
            setColor(colors.red);
          } else {
            setResult("خطأ ما حصل! الرجاء المحاولة لاحقًا");
            setColor(colors.red);
          }
        }}
      >
        <div
          css={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "60%",
            [mq[1]]: {
              width: "100%",
              display: "block",
            },
          }}
        >
          <Label>رابط المدونة</Label>
          <Input
            type="text"
            onChange={(event) => setUrl(event.target.value)}
            placeholder="رابط المدوّنة"
          />
          <Button
            type="submit"
            css={{
              marginTop: 0,
            }}
          >
            تحقّق
          </Button>
        </div>
        <p
          css={{
            marginTop: "0.5rem",
            color: color,
          }}
        >
          {result}
        </p>
      </form>
    </>
  );
}

function AddNewForm() {
  const [query, setQuery] = useState({
    title: "",
    url: "",
    feedUrl: "",
    creator: "",
    country: "",
    category: "",
    tags: "",
    date: "",
  });
  const [validation, setValidation] = useState({
    title: true,
    url: true,
    feedUrl: true,
    creator: true,
    country: true,
    category: true,
    tags: true,
    date: true,
  });
  const [captcha, setCaptcha] = useState("");
  const [response, setResponse] = useState("");
  const [processing, setProcessing] = useState(false);

  const url = `${API_URL}/suggest/?title=${query.title}&url=${query.url}&feedUrl=${query.feedUrl}&creator=${query.creator}&country=${query.country}&category=${query.category}&tags=${query.tags}&date=${query.date}`;
  const question = `${firstNum} + ${secondNum}`;

  return (
    <>
      <h4>أضف مدونة جديدة </h4>
      <p>
        في حال لم تكن المدونة موجودة ضمن قاعدة بياناتنا الرجاء ملئ النموذج أدناه
        وإرساله لنا. تُراجع الطلبات في غضون أسبوع إلى عشرة أيام؛ قبل أن تُضاف
        بالفعل إلى قاعدة البيانات
      </p>
      <div
        css={{
          direction: "rtl",
        }}
      >
        <form
          onSubmit={async (event) => {
            event.preventDefault();
            setResponse("نُعالج طلبك، يُرجى الإنتظار...");
            if (captcha == answer) {
              setProcessing(true);
              try {
                const res = await axios({
                  method: "get",
                  url: url,
                  headers: {
                    Authorization:
                      "Basic ZWxmZWhyZXN0Ok5qNG1NSlEwd0Z6MUJTakR6THQz",
                  },
                });
                setResponse(res.data.msg);
                if (res.data.status == 201) {
                  setQuery({
                    title: "",
                    url: "",
                    feedUrl: "",
                    creator: "",
                    country: "",
                    category: "",
                    tags: "",
                    date: "",
                  });
                  setCaptcha("");
                  setValidation({
                    title: true,
                    url: true,
                    feedUrl: true,
                    creator: true,
                    country: true,
                    category: true,
                    tags: true,
                    date: true,
                  });
                } else {
                  setProcessing(false);
                }
              } catch (error) {
                setResponse(error);
                setProcessing(false);
              }
            } else {
              setResponse("حل خاطئ للمعادلة أعلاه!");
              setProcessing(false);
            }
          }}
        >
          <Option>
            <Label>عنوان المدوّنة *</Label>
            <Input
              type="text"
              placeholder={"عنوان المدوّنة"}
              value={query.title}
              onChange={(event) =>
                setQuery({ ...query, title: event.target.value })
              }
              onBlur={(event) =>
                isEmpty(event.target.value)
                  ? setValidation({ ...validation, title: false })
                  : setValidation({ ...validation, title: true })
              }
              css={{ border: validation.title || `2px solid ${colors.red}` }}
            />
          </Option>
          <Option>
            <Label>رابط المدوّنة *</Label>
            <Input
              type="text"
              placeholder={"https://example.com"}
              value={query.url}
              onChange={(event) =>
                setQuery({ ...query, url: event.target.value })
              }
              onBlur={(event) =>
                isValidUrl(event.target.value)
                  ? setValidation({ ...validation, url: true })
                  : setValidation({ ...validation, url: false })
              }
              css={{ border: validation.url || `2px solid ${colors.red}` }}
            />
          </Option>
          <Option>
            <Label>
              رابط الخلاصات *{" "}
              <Creatorlink
                to="/info/rss"
                css={{ cursor: "pointer" }}
                as={Link}
                title="ما هو رابط الخلاصات؟"
              >
                (؟)
              </Creatorlink>
            </Label>
            <Input
              type="text"
              placeholder={"https://example.com/feed"}
              value={query.feedUrl}
              onChange={(event) =>
                setQuery({ ...query, feedUrl: event.target.value })
              }
              onBlur={(event) =>
                isValidUrl(event.target.value)
                  ? setValidation({ ...validation, feedUrl: true })
                  : setValidation({ ...validation, feedUrl: false })
              }
              css={{
                border: validation.feedUrl || `2px solid ${colors.red}`,
              }}
            />
          </Option>
          <Option>
            <Label>المدون/ة</Label>
            <Input
              type="text"
              placeholder={"اسم المدون/ة"}
              value={query.creator}
              onChange={(event) =>
                setQuery({ ...query, creator: event.target.value })
              }
            />
          </Option>

          <Option>
            <Label>البلد</Label>
            <Input
              type="text"
              placeholder={"البلد الأم للمدوّن"}
              value={query.country}
              onChange={(event) =>
                setQuery({ ...query, country: event.target.value })
              }
            />
          </Option>
          <Option>
            <Label>التصنيف</Label>
            <Input
              type="text"
              placeholder={"عام أو تقنية أو فنون إلخ"}
              value={query.category}
              onChange={(event) =>
                setQuery({ ...query, category: event.target.value })
              }
            />
          </Option>
          <Option>
            <Label>الوسوم</Label>
            <Input
              type="text"
              placeholder={"وسم، وسم، وسم"}
              value={query.tags}
              onChange={(event) =>
                setQuery({ ...query, tags: event.target.value })
              }
            />
          </Option>
          <Option>
            <Label>سنة الإنطلاق</Label>
            <Input
              type="text"
              placeholder={"2005"}
              value={query.date}
              onChange={(event) =>
                setQuery({ ...query, date: event.target.value })
              }
              onBlur={(event) =>
                isOnlyNumber(event.target.value)
                  ? setValidation({ ...validation, date: true })
                  : setValidation({ ...validation, date: false })
              }
              css={{ border: validation.date || `2px solid ${colors.bad}` }}
            />
          </Option>
          <Option>
            <Label>الرجاء حل المعادلة التالية قبل الإرسال {question}</Label>
            <Input
              type="text"
              value={captcha}
              onChange={(event) => setCaptcha(event.target.value)}
            />
          </Option>
          <p
            css={{
              marginTop: "1rem",
              marginBottom: "1rem",
              fontWeight: 600,
            }}
          >
            فقط الحقول المُنجمّة * إلزامية
          </p>
          {processing || (
            <Button
              type="submit"
              css={{
                paddingRight: "1.2rem",
                paddingLeft: "1.2rem",
              }}
            >
              أرسل
            </Button>
          )}
          <p
            css={{
              marginTop: "0.5rem",
            }}
          >
            {response}
          </p>
        </form>
      </div>
    </>
  );
}

function WhatisBlog() {
  return (
    <div>
      <h4>إطلع على شروط قبول مدوّنة</h4>
      <p>
        المدوّنة هي موقع ويب يطرح فيه المدوّن آراءه الشخصية، تجاربه، يومياته،
        أفكاره، خواطره، إلى ما هنالك من المدخلات النصيّة ذات الطابع غير الرسمي
        غالبًا على غرار المذكرات.
      </p>
      <p>
        <strong>
          حتى تُقبل المدوّنة ضمن مجتمع الفهرست ينبغي أن تراعي الشروط التالية:
        </strong>
      </p>
      <ul
        css={{
          [mq[1]]: {
            margin: "0.5rem",
          },
        }}
      >
        <li>أن تُعرّف نفسها كمدوّنة</li>
        <li>أن تكون إما:</li>
        <ul>
          <li>
            مدوّنة شخصيّة يكتب فيها شخص بعينه. نُشر أحدث مواضيعها في غضون الأشهر
            الستّة الفائتة.
          </li>
          <li>
            أو مدوّنة جماعية يكتب فيها 2-3 مدونون، لا يتم دفع الأجور لكتّابها،
            ولا تفتح بابًا للاستكتاب.
          </li>
        </ul>
        <li>أن لا تكون مدوّنة دعائية أو معظم محتواها دعائي.</li>
        <li>أن لا تنحصر ضمن مواضيع الربح من الإنترنت.</li>
        <li>أن لا تكون منصّةً للنشر أو ضمن منصةٍ للنشر.</li>
        <li>أن تنشر باللغة العربيّة (ولو إلى جانب لغاتٍ أخرى).</li>
        <li>
          أن لا تنشر محتوىً{" "}
          <GreenLink href="https://ar.wikipedia.org/wiki/%D8%BA%D9%8A%D8%B1_%D9%85%D9%86%D8%A7%D8%B3%D8%A8_%D9%84%D9%84%D8%B9%D9%85%D9%84">
            غير مناسبٍ للعمل
          </GreenLink>
        </li>
      </ul>
      <p>
        <strong>سيتم إزالة المدوّنات التي يثبت أنها:</strong>
      </p>
      <ul>
        <li>تُخالف أحد الشروط السابقة بعد إضافتها إلى موقع الفهرست</li>
        <li>تنتحل شخصيات حقيقية.</li>
        <li>أعمالها منتحلة لكتّاب آخرون.</li>
        <li>تنشر محتويات غير مناسبة للعمل.</li>
      </ul>
    </div>
  );
}

function AddNewBlog() {
  return (
    <Layout>
      <SEO title="إضافة مدوّنة" />
      <div
        css={{
          boxShadow: "1px 2px 15px #e5e5e5",
          margin: "1.5rem auto",
          padding: "2rem",
          backgroundColor: colors.light,
        }}
      >
        <h3>أضف مدونة جديدة</h3>
        <p>
          الفهرست هو جهد مجتمعي لجمع شتات المدونات العربية، فهرستها والتعريف
          بها. تحتوي قاعدة بياناتنا حاليًا على أكثر من 500 مدوّنة عربيّة نشطة.
          نعمل على إضافة المزيد كما نأمل من الجميع المساهمة في بناء الفهرست.
        </p>

        <CheckifExist />

        <WhatisBlog />

        <AddNewForm />
      </div>
    </Layout>
  );
}

export default AddNewBlog;
